import styled from '@emotion/styled';
import { DynamicStyle } from 'facepaint';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export type LayoutStyles = {
  customStyles?: DynamicStyle[];
  showBetButton?: boolean;
};

export const Content = styled.main<LayoutStyles>(props => {
  const base = mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1280px',
    margin: [
      `${defaultTheme.spacing.s} auto 0`,
      `${defaultTheme.spacing.s} auto 0`,
      `${defaultTheme.spacing.xxl} auto 0`,
      `${defaultTheme.spacing.xxl} auto 0`,
    ],
    paddingBottom: ['200px', '200px', '200px', '144px'],
    color: defaultTheme.text.default,
    backgroundColor: defaultTheme.background.lightGray,
  });
  if (props.customStyles) {
    return [...base, ...props.customStyles];
  }
  return base;
});

export const ButtonWrapper = styled.div(() =>
  mq({
    display: ['none', 'none', 'flex', 'flex'],
    position: 'fixed',
    right: '80px',
    bottom: '40px',
    zIndex: 1000,
  }),
);

export const Wrapper = styled.div(() => ({
  display: 'grid',
  gridTemplateRows: 'auto 1fr',
  height: '100%',
  backgroundColor: defaultTheme.background.lightGray,
}));
